import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { is4xxStatusCode } from "common/number-helper";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { insMarketsstateId } from "components/pages/markets";
import { useDeleteMarket } from "hooks/use-delete-market";
import { language } from "language/default";
import { setSelectedRowsState } from "store/grids";
import { closeDialog, setMessagesDialog } from "store/messages-dialog";
export const InsDeleteBenchmarkDialogAction = () => {
    const dispatch = useDispatch();
    const [, deleteMarketMutation] = useDeleteMarket();
    const selectedRows = useSelector((state) => state.grids.state[insMarketsstateId]?.selectedRows, isEqual) ?? [];
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                deleteMarketMutation({ deleteMultipleMarketsRequest: { marketIds: selectedRows } }, {})?.then((value) => {
                    const isError = is4xxStatusCode(value?.status);
                    batch(() => {
                        dispatch(setSelectedRowsState({
                            id: insMarketsstateId,
                            selectedRows: []
                        }));
                        dispatch(closeDialog());
                        if (isError) {
                            const errorMessages = Object.values(value.body?.errors || {}).flat();
                            const allLines = errorMessages.flatMap((msg) => msg.split("\n\n").filter((line) => line.trim()));
                            dispatch(setMessagesDialog({
                                functionName: MessagesDialogFunctionName.Default,
                                messages: allLines.map((line) => ({ message: line })),
                                title: language.en.modal.benchmarkCreation.benchmarkDeletion.deleteBenchmarkErrorTitle
                            }));
                        }
                    });
                });
            } }),
        React.createElement(CloseDialogButton, null));
};
